import React from 'react';
import { IconType } from '../../Enums/IconType.enum';
import styles from './Icon.module.scss';

interface Props {
	type: IconType;
	backgroundColor?: string;
	className?: string;
	badge?: boolean;
}

const Icon: React.FC<Props> = ({ type, backgroundColor, className, badge }) => {
	const icon = (
		<img className={className} src={`/dist/icons/${type}`} alt='icon' />
	);

	if (backgroundColor) {
		return (
			<div
				className={styles.wrapper}
				style={{ backgroundColor: backgroundColor }}>
				{icon}
				{badge && <div className={styles.badge} />}
			</div>
		);
	}

	return icon;
};

export default Icon;
